import { InjectionKey } from "@lib/svelte-typed-context";
import { BehaviorSubject } from "rxjs";

export const containerQueryWidthContextToken = Symbol(
    "containerQueryWidthContextToken"
) as InjectionKey<BehaviorSubject<number>>;
